import { getDefaultExportFromCjs as r } from "./_commonjsHelpers.js";
import { __require as t } from "../node_modules/.pnpm/use-sync-external-store@1.5.0_react@19.1.0/node_modules/use-sync-external-store/shim/index.js";
var e = t();
const m = /* @__PURE__ */ r(e);
export {
  m as default
};
//# sourceMappingURL=index.js.map
